import type { StepTask } from '../../types'
import { Field, ReadonlyValue, SectionHeader, getParams } from './fields'
import { AmlProposedConfig } from './AmlProposedConfig'

export interface AmlDrawerProps {
  task: StepTask
  onChange: (updater: (t: StepTask) => StepTask) => void
}

export function AmlDrawer({ task }: AmlDrawerProps) {
  const params = getParams(task)
  // Real workflow JSON stores AML config as name (screening type, e.g. "pep")
  // and providerName (e.g. "refinitiv" / "complyadvantage").
  const screeningType = (params.name as string | undefined) ?? ''
  const provider = (params.providerName as string | undefined) ?? ''

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Existing ops center workflow config" />

      <Field label="Screening Type">
        <ReadonlyValue>{screeningType || '—'}</ReadonlyValue>
      </Field>

      <Field label="Provider Name">
        <ReadonlyValue>{provider || '—'}</ReadonlyValue>
      </Field>

      <SectionHeader title="Proposed additional config" hint="Mockup · not saved" />
      <p className="text-[10px] text-[#5b6b85] -mt-2">
        Grouped by the v2 config file each setting lives in.
      </p>

      <AmlProposedConfig provider={provider || undefined} />
    </div>
  )
}
